import {
  Menu,
} from '@/internal';

export default (payload = {}) => {
  return new Menu({
    title: 'Admin',
    open: true,
    menuItems: [
      {
        route: window.app.findRouteByName('admin/index'),
      },
      {
        route: window.app.findRouteByName('admin/product-feedback'),
      },
      {
        route: window.app.findRouteByName('admin/brand-board'),
      },
      {
        route: window.app.findRouteByName('admin/debug/request'),
      },
      {
        route: window.app.findRouteByName('admin/survey-responses'),
      },
      {
        route: window.app.findRouteByName('admin/users/search'),
      }
    ],
  });
};
